<template>
    <div class="w-100">
        <v-flex xs12 class="mb-4" v-if="actions.length">
            <draggable v-model="actions" @start="drag=true" @end="drag=false" class="draggable-row">
                <v-layout
                    class="ma-0 pa-0 mb-2"
                    v-for="(action, indexAction) in actions"
                    :key="`action${indexAction}`"
                    column
                >
                    <v-flex xs12 d-flex align-center v-if="action">
                        <div class="close-btn mr-1" style="width: 20px">
                            <v-img max-height="18px" max-width="18px" :src="require('@/assets/icons/draggable.svg')" class="d-inline-flex"/>
                        </div>
                        <v-flex class="d-inline-flex mr-1" style="width: 25px">
                            {{indexAction + 1}}.
                        </v-flex>
                        <v-flex class="action-row">
                            <div class="d-inline-flex" style="overflow-wrap: anywhere;" v-if="action.type == 1 && action.device">
                                {{action.device.name}} ({{ action.device.location }})
                            </div>
                            <div class="d-inline-flex" style="overflow-wrap: anywhere;" v-if="action.type == 2 && action.scenario">
                                {{action.scenario.name}} ({{ action.scenario.location }})
                            </div>
                            <div class="d-inline-flex" v-if="action.type == 3 && action.group">
                                {{action.group.name}}
                            </div>
                            <div v-if="action.type == 4" class="d-inline-flex">
                                Задержка
                            </div>
                            <div class="close-btn mx-1" style="width: 18px">
                                <v-img max-height="18px" max-width="18px" :src="require('@/assets/icons/arrow_icon.svg')" class="d-inline-flex"/>
                            </div>
                            <div v-if="action.state" class="d-inline-flex ml-1">{{action.state.name}}</div>
                            <div
                                v-else-if="
                                    action.device && action.device.device_type == 12 &&
                                     action.variable && action.variable.value_type == 'select'

                                "
                                class="d-inline-flex ml-1"
                            >
                                Выкл
                            </div>
                            <div v-if="action.number != null" class="d-inline-flex ml-1">{{action.number}}</div>
                            <div v-if="action.type == 4" class="d-inline-flex ml-1">
                                {{action.sleep}} сек.
                            </div>
                        </v-flex>
                        <div class="close-btn mx-2" @click="editAction(action)">
                            <v-img max-height="18px" max-width="18px" :src="require('@/assets/icons/edit_icon.svg')" class="d-inline-flex"/>
                        </div>
                        <div class="close-btn" @click="removeAction(indexAction)">
                            <v-img max-height="18px" :src="require('@/assets/icons/close_icon.svg')" class="d-inline-flex"/>
                        </div>
                    </v-flex>
                </v-layout>
            </draggable>
        </v-flex>
        <v-flex xs12 class="mb-2" v-if="showActionForm">
            <v-layout row class="action-form">
                <v-flex :xs5="type == 4" :xs12="type != 4" :pr-3="type == 4" class="d-inline-flex">
                    <v-select
                        v-model="type"
                        placeholder="Тип действия"
                        class="input-form-grey scenario-action"
                        :items="actionsValues"
                        item-text="name"
                        item-value="value"
                        :menu-props="{
                            bottom: true,
                            offsetY: true,
                            closeOnContentClick: true,
                        }"
                        @change="updateType"
                    >
                        <template #item="{item}">
                            <v-flex class="menu-item__scenario-action d-inline-flex align-center">
                                <v-img
                                    max-height="20px"
                                    max-width="20px"
                                    :src="require(`@/assets/scenario-form/${item.icon}_icon.svg`)"
                                    class="d-inline-flex mr-3"
                                />
                                {{item.name}}
                            </v-flex>
                        </template>
                        <template #selection="{item}">
                            <v-flex class="d-inline-flex align-center">
                                <v-img
                                    max-height="20px"
                                    max-width="20px"
                                    :src="require(`@/assets/scenario-form/${item.icon}_icon.svg`)"
                                    class="d-inline-flex mr-3"
                                />
                                {{item.name}}
                            </v-flex>
                        </template>
                        <template #no-data>
                            <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                        </template>
                    </v-select>
                </v-flex>
                <v-flex xs12 v-if="type == 1">
                    <v-select
                        v-model="device"
                        placeholder="Устройство"
                        class="input-form-grey"
                        :items="devices"
                        item-value="uid"
                        :menu-props="{
                            bottom: true,
                            offsetY: true,
                            closeOnContentClick: true,
                        }"
                        return-object
                        @change="updateVariable"
                    >
                        <template #item="{item}">
                            <v-flex style="padding: 10px 22px">{{item.name}} - {{item.location}}</v-flex>
                        </template>
                        <template #selection="{item}">
                            <v-flex>{{item.name}} - {{item.location}}</v-flex>
                        </template>
                        <template #no-data>
                            <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                        </template>
                    </v-select>
                </v-flex>
                <v-flex xs12 v-if="type == 2">
                    <v-select
                        v-model="scenario"
                        placeholder="Сценарий"
                        class="input-form-grey"
                        :items="scenarios"
                        item-value="uid"
                        :menu-props="{
                            bottom: true,
                            offsetY: true,
                            closeOnContentClick: true,
                        }"
                        return-object
                        @change="updateVariable"
                    >
                        <template #item="{item}">
                            <v-flex style="padding: 10px 22px">{{item.name}} - {{item.location}}</v-flex>
                        </template>
                        <template #selection="{item}">
                            <v-flex>{{item.name}} - {{item.location}}</v-flex>
                        </template>
                        <template #no-data>
                            <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                        </template>
                    </v-select>
                </v-flex>
                <v-flex xs12 v-if="type == 3">
                    <v-select
                        v-model="group"
                        placeholder="Группа сценариев"
                        class="input-form-grey"
                        :items="groups"
                        item-value="uid"
                        :menu-props="{
                            bottom: true,
                            offsetY: true,
                            closeOnContentClick: true,
                        }"
                        return-object
                        @change="updateVariable"
                    >
                        <template #item="{item}">
                            <v-flex style="padding: 10px 22px">{{item.name}} - {{item.location}}</v-flex>
                        </template>
                        <template #selection="{item}">
                            <v-flex>{{item.name}} - {{item.location}}</v-flex>
                        </template>
                        <template #no-data>
                            <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                        </template>
                    </v-select>
                </v-flex>
                <v-flex xs6 class="modal-row d-flex pr-2" v-if="device && device.uid">
                    <v-select
                        v-if="available[`device_${device.device_type}`].length"
                        v-model="variable"
                        placeholder="Вариант"
                        class="input-form-grey scenario-state"
                        :items="available[`device_${device.device_type}`]"
                        item-text="name"
                        item-value="key"
                        :menu-props="{
                            bottom: true,
                            offsetY: true,
                            closeOnContentClick: true,
                        }"
                        return-object
                        :disabled="available[`device_${device.device_type}`].length == 1"
                        @change="updateState"
                    >
                        <template #item="{item}">
                            <v-flex class="menu-item__scenario-state d-inline-flex align-center">
<!--                                <v-img-->
<!--                                    max-height="20px"-->
<!--                                    max-width="20px"-->
<!--                                    :src="require(`@/assets/scenario-form/${item.key == 'run' ? 'run' : 'state'}_icon.svg`)"-->
<!--                                    class="d-inline-flex mr-3"-->
<!--                                />-->
                                {{item.name}}
                            </v-flex>
                        </template>
                        <template #selection="{item}">
                            <v-flex class="d-inline-flex align-center">
<!--                                <v-img-->
<!--                                    max-height="20px"-->
<!--                                    max-width="20px"-->
<!--                                    :src="require(`@/assets/scenario-form/${item.key == 'run' ? 'run' : 'state'}_icon.svg`)"-->
<!--                                    class="d-inline-flex mr-3"-->
<!--                                />-->
                                {{item.name}}
                            </v-flex>
                        </template>
                        <template #no-data>
                            <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                        </template>
                    </v-select>
                    <div v-else class="red-text">
                        Нет доступных действий для этого устройства
                    </div>
                </v-flex>
                <v-flex xs6 class="modal-row d-flex pr-2" v-if="scenario && scenario.uid">
                    <v-select
                        v-if="available.scenario.length"
                        v-model="variable"
                        placeholder="Вариант"
                        class="input-form-grey scenario-state"
                        :items="available.scenario"
                        item-text="name"
                        item-value="key"
                        :menu-props="{
                            bottom: true,
                            offsetY: true,
                            closeOnContentClick: true,
                        }"
                        return-object
                        :disabled="available.scenario.length == 1"
                        @change="updateState"
                    >
                        <template #item="{item}">
                            <v-flex class="menu-item__scenario-state d-inline-flex align-center">
<!--                                <v-img-->
<!--                                    max-height="20px"-->
<!--                                    max-width="20px"-->
<!--                                    :src="require(`@/assets/scenario-form/${item.key == 'run' ? 'run' : 'state'}_icon.svg`)"-->
<!--                                    class="d-inline-flex mr-3"-->
<!--                                />-->
                                {{item.name}}
                            </v-flex>
                        </template>
                        <template #selection="{item}">
                            <v-flex class="d-inline-flex align-center">
<!--                                <v-img-->
<!--                                    max-height="20px"-->
<!--                                    max-width="20px"-->
<!--                                    :src="require(`@/assets/scenario-form/${item.key == 'run' ? 'run' : 'state'}_icon.svg`)"-->
<!--                                    class="d-inline-flex mr-3"-->
<!--                                />-->
                                {{item.name}}
                            </v-flex>
                        </template>
                        <template #no-data>
                            <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                        </template>
                    </v-select>
                    <div v-else class="red-text">
                        Нет доступных действий для сценария
                    </div>
                </v-flex>
                <v-flex xs6 class="modal-row d-flex pr-2" v-if="group && group.uid">
                    <v-select
                        v-if="available.scenario_group"
                        v-model="variable"
                        placeholder="Вариант"
                        class="input-form-grey scenario-state"
                        :items="available.scenario_group"
                        item-text="name"
                        item-value="key"
                        :menu-props="{
                            bottom: true,
                            offsetY: true,
                            closeOnContentClick: true,
                        }"
                        return-object
                        :disabled="available.scenario_group.length == 1"
                        @change="updateState"
                    >
                        <template #item="{item}">
                            <v-flex class="menu-item__scenario-state d-inline-flex align-center">
<!--                                <v-img-->
<!--                                    max-height="20px"-->
<!--                                    max-width="20px"-->
<!--                                    :src="require(`@/assets/scenario-form/${item.key == 'run' ? 'run' : 'state'}_icon.svg`)"-->
<!--                                    class="d-inline-flex mr-3"-->
<!--                                />-->
                                {{item.name}}
                            </v-flex>
                        </template>
                        <template #selection="{item}">
                            <v-flex class="d-inline-flex align-center">
<!--                                <v-img-->
<!--                                    max-height="20px"-->
<!--                                    max-width="20px"-->
<!--                                    :src="require(`@/assets/scenario-form/${item.key == 'run' ? 'run' : 'state'}_icon.svg`)"-->
<!--                                    class="d-inline-flex mr-3"-->
<!--                                />-->
                                {{item.name}}
                            </v-flex>
                        </template>
                        <template #no-data>
                            <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                        </template>
                    </v-select>
                    <div v-else class="red-text">
                        Нет доступных действий для группы сценариев
                    </div>
                </v-flex>
                <v-flex xs7 class="modal-row d-flex" v-if="type == 4">
                    <v-text-field
                        v-model="sleep"
                        placeholder="Количество сек."
                        class="input-form-grey error-field"
                        type="number"
                        min="60"
                        :rules="rules.min"
                        @keypress="checkNumber($event)"
                    ></v-text-field>
                </v-flex>
                <v-flex xs6 class="modal-row d-flex pl-1" v-if="variable">
                    <v-flex xs12 v-if="variable.value_type == 'select'">
                        <v-select
                            v-model="state"
                            :placeholder="variable.name"
                            class="input-form-grey scenario-variable"
                            :items="variable.values"
                            item-text="name"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            return-object
                        >
                            <template #item="{item}">
                                <v-flex class="menu-item__scenario-variable d-inline-flex align-center">{{item.name}}</v-flex>
                            </template>
                            <template #no-data>
                                <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex xs12 v-if="variable.value_type == 'int'">
                        <v-text-field
                            v-model="number"
                            :placeholder="variable.name"
                            class="input-form-grey"
                            type="number"
                            min="0"
                            max="100"
                            :rules="rules.max"
                            @keypress="checkNumber($event)"
                        ></v-text-field>
                    </v-flex>
                </v-flex>
                <v-flex xs12 class="modal-row d-flex justify-end mt-1">
                    <v-btn class="btn-grey main-text" @click="closeAddAction">
                        Сбросить
                    </v-btn>
                    <v-btn class="btn-grey main-text ma-0" :disabled="disabledAdd" @click="addAction">
                        Добавить
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs12 mb-4 v-if="!showActionForm">
            <v-btn class="btn-light-grey" @click="openAddAction">
                Добавить действие +
            </v-btn>
        </v-flex>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import {isNumber} from "@/utils";

export default {
    name: "ActionsForm",
    components: {draggable},
    props: {
        actionsData: {
            type: Array,
            default: () => [],
        },
        devices: {
            type: Array,
            default: () => [],
        },
        scenarios: {
            type: Array,
            default: () => [],
        },
        groups: {
            type: Array,
            default: () => [],
        },
        available: {
            type: Object,
            default: () => {},
        },
        edit: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            showActionForm: false,
            type: null,
            device: null,
            scenario: null,
            group: null,
            variable: null,
            state: null,
            number: null,
            sleep: null,
            editItem: null,
            actionsValues: [
                {
                    name: "Устройство",
                    value: 1,
                    icon: "device",
                },
                {
                    name: "Сценарий",
                    value: 2,
                    icon: "scenario",
                },
                {
                    name: "Группа сценариев",
                    value: 3,
                    icon: "group_scenario",
                },
                {
                    name: "Задержка",
                    value: 4,
                    icon: "timeout",
                },
            ],
            actions: [],
            rules: {
                min: [value => !!value && value > 59 || 'Минимальное значение 60 сек.'],
                max: [v => !!v && v < 101 || "Максимальное значение 100"],
            },
        };
    },
    computed: {
        disabledAdd() {
            return !this.type ||
                (this.type == 1 && !this.device) ||
                (this.type == 2 && !this.scenario) ||
                (this.type == 3 && !this.group) ||
                (this.type == 4 && !this.sleep) ||
                (this.type != 4 && !this.variable) ||
                (this.variable && this.variable.value_type == 'select' && !this.state) ||
                (this.variable && this.variable.value_type == 'int' && (!this.number || this.number > 100));
        },
    },
    watch: {
        edit(val) {
            if (val) {
                this.setActionsEdit();
            }
        },
        device(val) {
            if (val) {
                if (this.available[`device_${val.device_type}`].length == 1) {
                    this.variable = this.available[`device_${val.device_type}`][0];
                }
            }
        },
        group(val) {
            if (val && this.available.scenario_group.length == 1) {
                this.variable = this.available.scenario_group.scenario[0];
            }
        },
        scenario(val) {
            if (val && this.available.scenario.length == 1) {
                this.variable = this.available.scenario[0];
            }
        },
    },
    methods: {
        setActionsEdit() {
            this.actions = [];
            this.edit.forEach((el) => {
                let action = {};
                if (el.device) {
                    action.device = el.device;
                    action.type = 1;
                    let device_type = action.device ? action.device.device_type : "";
                    let availArr = this.available[`device_${device_type}`];
                    if (availArr) {
                        action.variable = availArr.find((avail) => {
                            return _.has(el.state, avail.key);
                        });
                        let value_type = action.variable ? action.variable.value_type : null;
                        if (value_type == "select") {
                            action.state = action.variable.values.find((action_value) => {
                                return action_value.value == el.state[action.variable.key];
                            });
                        }
                        if (value_type == "int") {
                            action.number = el.state.value;
                        }
                    }
                }
                if (el.scenario) {
                    action.scenario = el.scenario;
                    action.type = 2;
                    let availArr = this.available.scenario;
                    if (availArr) {
                        action.variable = availArr.find((avail) => {
                            return _.has(el.state, avail.key);
                        });
                        let value_type = action.variable ? action.variable.value_type : null;
                        if (value_type == "select") {
                            action.state = action.variable.values.find((action_value) => {
                                return action_value.value == el.state[action.variable.key];
                            });
                        }
                        if (value_type == "int") {
                            action.number = el.state.value;
                        }
                    }
                }
                if (el.scenario_group) {
                    action.group = el.scenario_group;
                    action.type = 3;
                    let availArr = this.available.scenario_group;
                    if (availArr) {
                        action.variable = availArr.find((avail) => {
                            return _.has(el.state, avail.key);
                        });
                        let value_type = action.variable ? action.variable.value_type : null;
                        if (value_type == "select") {
                            action.state = action.variable.values.find((action_value) => {
                                return action_value.value == el.state[action.variable.key];
                            });
                        }
                        if (value_type == "int") {
                            action.number = el.state.value;
                        }
                    }
                }
                if (el.sleep) {
                    action.sleep = el.sleep;
                    action.type = 4;
                }
                this.actions.push(action);
            });
            this.actions = _.orderBy(this.actions, ["index"]);
            this.$emit('update:actionsData', this.actions);
        },
        openAddAction() {
            this.showActionForm = true;
        },
        closeAddAction() {
            this.showActionForm = false;
            this.editItem = null;
            this.type = null;
            this.updateType();
        },
        addAction() {
            let action = {};
            if (this.type) {
                action.type = this.type;
            }
            if (this.device || this.scenario || this.group) {
                if (this.device) {
                    action.device = this.device;
                }
                if (this.scenario) {
                    action.scenario = this.scenario;
                }
                if (this.group) {
                    action.group = this.group;
                }
                action.variable = this.variable;
                if (this.state || (this.device && this.variable.value_type == 'select' && this.device.device_type == 12)) {
                    action.state = this.state;
                }
                if (this.number) {
                    action.number = this.number;
                }
            }
            if (this.sleep) {
                action.sleep = this.sleep;
            }
            if (this.editItem) {
                let equal = null;
                this.actions.forEach((el, index) => {
                    if (_.isEqual(this.editItem, el)) {
                        equal = index;
                    }
                });
                if (equal != null) {
                    this.actions[equal] = action;
                } else {
                    this.actions.push(action);
                }
            } else {
                this.actions.push(action);
            }
            this.editItem = null;
            this.$emit('update:actionsData', this.actions);
            this.closeAddAction();
        },
        removeAction(item) {
            this.actions.splice(item, 1);
            this.$emit('update:actionsData', this.actions);
        },
        editAction(item) {
            this.editItem = JSON.parse(JSON.stringify(item));
            if (this.editItem.type) {
                this.type = this.editItem.type;
            }
            if (this.editItem.device || this.editItem.scenario || this.editItem.group) {
                if (this.editItem.device) {
                    this.device = this.editItem.device;
                }
                if (this.editItem.scenario) {
                    this.scenario = this.editItem.scenario;
                }
                if (this.editItem.group) {
                    this.group = this.editItem.group;
                }
                this.variable = this.editItem.variable;
                if (
                    this.editItem.state ||
                    (this.editItem.device && this.editItem.variable.value_type == 'select' && this.editItem.device.device_type == 12)
                ) {
                    this.state = this.editItem.state;
                }
                if (this.editItem.number) {
                    this.number = this.editItem.number;
                }
            }
            if (this.editItem.sleep) {
                this.sleep = this.editItem.sleep;
            }
            this.openAddAction();
        },
        updateState() {
            this.state = null;
            this.number = null;
        },
        updateVariable() {
            this.variable = null;
            this.updateState();
        },
        updateType() {
            this.device = null;
            this.scenario = null;
            this.group = null;
            this.sleep = null;
            this.updateVariable();
        },
        checkNumber(evt) {
            return isNumber(evt);
        },
        update() {
            this.$emit('update:actionsData', this.actions);
        },
    }
}
</script>

<style lang="scss" scoped>
.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
    margin-right: 10px;
}

.btn-gradient.v-btn {
    max-width: 165px;
}

.action-form {
    //background: #FFFFFF;
    //box-shadow: 0 2px 15px rgba(37, 37, 37, 0.1);
    //border-radius: 30px;
    width: 100%;
    //padding: 24px;
    margin: 0 0 8px 0;

    .v-input.v-text-field {
        background: rgba(255, 255, 255, 0.5) !important;
    }
}

.action-row {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 6px 0;
    //background: #F7F7F9;
    border-radius: 30px;
    min-height: 39px;
    font-size: 16px;
    line-height: 19px;
    align-self: center;
    align-items: center;
    width: calc(100% - 100px);

    &:hover {
        cursor: pointer;
    }
}

.draggable-row {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;
}

.v-input.input-form-grey {
    &::v-deep .v-input__control {
        .v-input__slot {
            margin-bottom: 0;
            top: 14px;

            .v-text-field__slot {
                height: 40px;
            }
        }

        .v-text-field__details {
            top: 12px;
            position: relative;
        }
    }

    &.error-field {
        &::v-deep .v-input__control {
            .v-text-field__details {
                top: 12px;
                position: relative;
            }
        }
    }
}
</style>